<template>
  <transition name="fade">
    <div
      class="toast"
      :class="{success:status==0,error:status==1,process:status==2,warn:status==3}"
      v-if="show"
    >
      <span class="icon">{{icon}}</span>
      <span class="text">{{i18n(info)}}</span>
    </div>
  </transition>
</template>

<script>
import store from "@/store";
import i18n from "@/i18n";
export default {
  props: {
    status: {
      type: Number,
      default: 0
    },
    forceFadeOut: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    icon() {
      switch (this.status) {
        case 0:
          return "\ue919";
        case 1:
          return "\ue9a6";
        case 3:
          return "\ue96a";
      }
    },
    info() {
      switch (this.status) {
        case 0:
          return "toast.success";
        case 1:
          return "toast.error";
        case 2:
          return "toast.pending";
        case 3:
          return "toast.warning";
      }
    },
    pending() {
      return store.state.requestPending;
    }
  },
  methods: {
    i18n(val) {
      return i18n.t(val);
    }
  },
  data() {
    return {
      show: false
    };
  },
  mounted() {
    this.show = true;
    if (!this.pending || this.forceFadeOut) {
      setTimeout(() => {
        this.show = false;
      }, 1300);
    }
  },
  watch: {
    pending(val) {
      if (val == false) {
        this.show = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.toast {
  @include flex;
  position: absolute;
  left: 50%;
  top: 91.5px;
  transform: translate(-50%, -50%);
  padding: 5px 14px;
  height: 40px;
  box-shadow: 2px 3px 10px -8px rgba(13, 36, 60, 1);
  border-radius: 4px;
  z-index: 300;

  &.success {
    background-color: $toast-success;
  }
  &.error {
    background-color: $toast-error;
  }
  &.process {
    background-color: $toast-process;
  }
  &.warn {
    background-color: $toast-warning;
  }
  .icon {
    color: $base-color;
    padding-right: 7px;
  }
  .text {
    color: #f3f3f3;
    font-size: 20px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
  transform: translate(-50%, -50%);
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate(-50%, -100%);
}
</style>


// WEBPACK FOOTER //
// src/components/toast.vue